import * as React from 'react';

// @ts-expect-error - imported from .js/.jsx file
import {LoadingIcon} from 'shells/icon/svg/loading-icon';

import styles from './trash-loading.module.css';

export class TrashLoading extends React.PureComponent<Record<any, any>> {
    render() {
        return (
            <div className={styles.container}>
                <LoadingIcon size={50} className={styles.loading} />
            </div>
        );
    }
}
